import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const updateStoreVoucherActivationAction = createAsyncThunk(
    'update-Vouchers-In-Store-activate-deativate',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/admins/api/store/${data}/toggle-status`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const updateStoreVoucherActivationInSlice = createSlice({
    name: 'update-Vouchers-In-Store-activate-deativate',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(updateStoreVoucherActivationAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(updateStoreVoucherActivationAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(updateStoreVoucherActivationAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const updateStoreVoucherActivationReducer = updateStoreVoucherActivationInSlice.reducer